module.exports = __webpack_public_path__ + "static/media/holocaust_in_bukovina_thumb.c4164d93.jpg";